import {CountDirections} from "./direction"
import BackgroundColor from "./backgroundColor";

export default async function Style(e) {
  const dir = ["С", "ССВ", "СВ", "ВСВ", "В", "ВЮВ", "ЮВ", "ЮЮВ", "Ю", "ЮЮЗ", "ЮЗ", "ЗЮЗ", "З", "ЗСЗ", "СЗ", "ССЗ"];
  const chartdata = {
    labels: e.type == "winddirect" ? dir : e.time,
    datasets: [],
  };
  if (e.type == "temperature") {
    BackgroundColor(e.values).then((colors) => {
      chartdata.datasets = [
        {
          label: "Температура",
          backgroundColor: colors,
          data: e.values,
        },
      ];
    });
  }
  if (e.type == "pressure") {
    chartdata.datasets = [
      {
        label: "Давление",
        backgroundColor: "#DDA0DD",
        data: e.values,
      },
    ];
  }
  if (e.type == "humidity") {
    chartdata.datasets = [
      {
        label: "Влажность",
        backgroundColor: "#1E90FF",
        data: e.values,
      },
    ];
  }
  if (e.type == "winddirect") {
    CountDirections(e.values).then((e) => {
      chartdata.datasets = [
        {
          label: "Направление ветра",
          backgroundColor: "#20B2AA",
          data: e,
        },
      ];
    });
  }
  if (e.type == "windspeed") {
    chartdata.datasets = [
      {
        label: "Скорость ветра",
        backgroundColor: "#008B8B",
        data: e.values.s,
      },
      {
        label: "Порывы ветра",
        backgroundColor: "#00CED1",
        data: e.values.r,
      },
    ];
  }
  return chartdata;
}
